import type { PlanTier } from '@/hooks/useSubscription';
import { planDisplayName } from '@/hooks/useSubscription';
import { cn } from '@/lib/utils';

/** One account-status badge across Profile and every account menu. */
export function AccountPlanBadge({
  plan,
  className,
}: {
  plan: PlanTier;
  className?: string;
}): JSX.Element {
  const tone =
    plan === 'pro_max'
      ? 'border-info/35 bg-info/12 text-foreground'
      : plan === 'pro'
        ? 'border-info/25 bg-info/8 text-foreground'
        : 'border-border/60 bg-background text-muted-foreground';

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-detail font-medium',
        tone,
        className,
      )}
    >
      {planDisplayName(plan)}
    </span>
  );
}
